// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__iICw7","links":"Footer_links__2VAlO","link":"Footer_link__sgKeT","logo":"Footer_logo__w79hm","icon":"Footer_icon__ctCoM"};